import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import Pagination from "@mui/material/Pagination";
import Paper from "@mui/material/Paper";
import Typography from "@mui/material/Typography";
import React, { useEffect } from "react";
import OrderData from "../../components/datatables/orders/OrderData";
import { useDispatch } from "react-redux";
import { getOrders } from "../../feature/orders/orderSlice";

const Order = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    window.scrollTo({ top: "0", behavior: "smooth" });
    dispatch(getOrders());
  }, [dispatch]);

  return (
    <Box
      component={Paper}
      // minWidth={100}
      // border={"1px solid #e9ebf0"}
      elevation={0}
    >
      <Box px={3} py={2}>
        <Typography variant='h4'>Orders</Typography>
      </Box>
      <Divider />
      <Box px={3} my={3}>
        <OrderData />
      </Box>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          m: 5,
        }}
      >
        <Pagination
          count={10}
          variant='outlined'
          showFirstButton
          showLastButton
          shape='rounded'
        />
      </Box>
    </Box>
  );
};

export default Order;
